import { Component, DestroyRef, ElementRef, EventEmitter, Input, OnInit, Output, inject, ChangeDetectionStrategy } from '@angular/core';
import { GlobalEventsService } from '@coin/shared/core/util-helpers';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgStyle } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LegacyComponentsModule } from '@coin/shared/core/feature-legacy-components';
import { TranslateModule } from '@ngx-translate/core';
import { V2TextInputComponent } from '@coin/shared/core/ui-storybook';
import { CMSContextMenuReplacement } from '../models/cms-context-menu-replacement';

@Component({
  selector: 'coin-contextmenu',
  templateUrl: './contextmenu.component.html',
  styleUrls: ['./contextmenu.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgStyle, FormsModule, LegacyComponentsModule, TranslateModule, V2TextInputComponent]
})
export class ContextmenuComponent implements OnInit {
  private readonly elementRef = inject(ElementRef);
  private readonly events = inject(GlobalEventsService);
  private readonly destroyRef = inject(DestroyRef);

  @Input() x = 0;
  @Input() y = 0;
  @Input() contextMenuReplacements!: CMSContextMenuReplacement[];

  @Output() addItemToContent = new EventEmitter<string>();
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() close = new EventEmitter<void>();

  public search: string;

  public get height(): number {
    return document.documentElement.clientHeight - this.y - 50;
  }

  public get filteredMenuReplacements(): CMSContextMenuReplacement[] {
    return this.contextMenuReplacements?.filter(
      item => !this.search?.trim() || item.value.toLowerCase().includes(this.search.toLowerCase())
    );
  }

  ngOnInit(): void {
    this.events
      .listen('click')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(event => this.clickout(event));
  }

  public clickout = (event: MouseEvent): void => {
    const clickedOutside = !this.elementRef.nativeElement.contains(event.target);

    if (clickedOutside) {
      this.close.emit();
    }
  };

  public addItem(item: CMSContextMenuReplacement): void {
    this.addItemToContent.emit(item.replacementText);
    this.close.emit();
  }
}
